import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';

const HalfImageHalfTextCardContainer = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(S.Container, props, children);

export { HalfImageHalfTextCardContainer };
HalfImageHalfTextCardContainer.propTypes = {
  children: PropTypes.node.isRequired
};